import React from 'react';

interface BallotIconProps {
  size?: number;
  color?: string;
  /** Optional accessible label. Defaults to ``aria-hidden`` decorative
   * usage when omitted (matches the mobile app's BallotIcon, which is
   * always paired with a text label). */
  title?: string;
}

/**
 * Ballot SVG icon — mirrors the mobile app's ``BallotIcon`` so the
 * web header / sidebar visuals match cross-platform.
 */
const BallotIcon: React.FC<BallotIconProps> = ({ size = 18, color = 'currentColor', title }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <rect x="4" y="2" width="16" height="20" rx="2" stroke={color} strokeWidth={1.8} />
    <path d="M8 7H16" stroke={color} strokeWidth={1.5} strokeLinecap="round" />
    <path d="M8 11H16" stroke={color} strokeWidth={1.5} strokeLinecap="round" />
    <path d="M8 15H13" stroke={color} strokeWidth={1.5} strokeLinecap="round" />
    <path
      d="M15 14L16.5 15.5L19 12.5"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BallotIcon;
